<!-- App -->
<!-- Description: Main file -->
<template>
  <!-- Declaring a wrapping element -->
  <transition name="animation">
    <router-view></router-view>
  </transition>
</template>

<!-- TypeScript code -->
<script>
    export default {
        name: 'App',
        components: {},
        props: {},
        data() {
            return {};
        },
        methods: {},
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // Importing custom global styles
  @import './assets/scss/normalize/normalize';

  .animation-enter-active {
    transition: opacity .4s
  }
  .animation-leave-active {
    display: none;
  }
  .animation-enter, .animation-leave-to {
    opacity: 0
  }
</style>